export const DEFAULT_STALE_TIME = 1000 * 60 * 60
